import React from "react";
import { InlineEditor } from "../../components/TinyMCE/InlineEditor";
import { ScrollWrapper } from "../helpers/module.helper";

export function HtmlModule(props) {
  const { clientKey, preview, updateModule = () => null } = props;
  const { html } = props.settings;
  let htmlContent = html;
  if (html)
    htmlContent = html
      .toString()
      .replace(/\[clientkey\]/gi, clientKey)
      .replace(/\[badgeno\]/gi, clientKey);

/*   if (!htmlContent) return <code>HTML</code>; */
  return (
    <ScrollWrapper {...props}>
      {/* {preview ? (
        
        <InlineEditor value={htmlContent} onChange={(value) => updateModule({ ...props.settings, html: value })} />
      ) : ( */}
        <div className="jir-scroll" style={{ height: "100%" }} dangerouslySetInnerHTML={{ __html: htmlContent }} />
      {/* )} */}
    </ScrollWrapper>
  );
}
